// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3x3lb","content":"styles_content__3B-5D"};